import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCode, faChessKnight, faMusic,
    faRobot, faLaptopCode, faPuzzlePiece,
    faPlane, faGamepad, faMicrochip, faComments,
    faBrain
} from '@fortawesome/free-solid-svg-icons';
import './About.css';

const About = () => {
    return (
        <div className="about page-enter">
            <div className="about-hero">
                <span className="about-eyebrow">Get to know me</span>
                <h1>About Me</h1>
                <p className="subtitle">
                    Computer Engineering student at the University of Waterloo, currently on co-op at Samsung Electronics Canada.
                    I build production-grade systems across data engineering, ML, embedded, and full-stack.
                </p>
            </div>

            <div className="about-content">
                <section className="bio">
                    <p>
                        Hi, I'm Vishnu — a Computer Engineering student at the University of Waterloo with a track record of shipping real things that solve real problems. 
                        Right now I'm on co-op at <strong>Samsung Electronics Canada</strong>, building Python data pipelines for the Network Sales team that automate financial reporting for enterprise telecom clients (Telus, Videotron, SaskTel) and prevent millions in recurring overbilling.
                    </p>
                    <p>
                        Before Samsung, I was a Developer Intern at <strong>Arctic Wolf</strong> working in a production cloud and DevOps environment — CI/CD pipelines, AWS infrastructure, Azure migrations, and reliability engineering. 
                        And in parallel, I'm part of the <strong>RBC Borealis Let's SOLVE It</strong> mentorship cohort, building WhaleGuard: a production ML pipeline that predicts North Atlantic Right Whale habitat to prevent ship-strike collisions (0.91 ROC-AUC).
                    </p>
                    <p>
                        My technical range spans the full stack — from custom PCB fabrication and STM32 firmware to Angular + Express web apps, Python ETL pipelines, and XGBoost model optimization. 
                        I learn fast, take ownership, and care about making systems that are genuinely reliable, not just demo-ready.
                    </p>

                    <div className="interests-section">
                        <h2>Interests & Passions</h2>
                        <div className="interests-grid">
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faRobot} />
                                <span>Robotics</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faLaptopCode} />
                                <span>Embedded Systems</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faCode} />
                                <span>Full-Stack Dev</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faBrain} />
                                <span>Machine Learning</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faPuzzlePiece} />
                                <span>Problem Solving</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faChessKnight} />
                                <span>Strategic Thinking</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faMusic} />
                                <span>Piano & Music</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faMicrochip} />
                                <span>Electronics</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faPlane} />
                                <span>Travel</span>
                            </div>
                            <div className="interest-item">
                                <FontAwesomeIcon icon={faComments} />
                                <span>Team Leadership</span>
                            </div>
                        </div>
                    </div>

                    <p>
                        Outside of engineering, I founded ArrowHack — my high school's first hackathon — and led a 30+ member Computer Club. 
                        I believe the best engineers are also strong communicators and collaborators, and I try to bring both to every team I join.
                    </p>
                </section>

                <div className="play-circuit-game">
                    <h3>Want a different kind of portfolio experience?</h3>
                    <button
                        onClick={() => window.launchPortfolioGame()}
                        className="circuit-game-button"
                    >
                        <FontAwesomeIcon icon={faGamepad} /> Play Portfolio Adventure
                    </button>
                </div>
            </div>
        </div>
    );
};

export default About;